import { SVGProps } from 'react';

const WalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="WalletIcon">
    <path
      d="M20.095 6.619H21v9.048h-.905v2.714a.905.905 0 0 1-.904.905H2.904A.905.905 0 0 1 2 18.38V3.905A.905.905 0 0 1 2.905 3H19.19a.905.905 0 0 1 .905.905v2.714Zm-1.81 9.048h-5.428a4.524 4.524 0 0 1 0-9.048h5.429v-1.81H3.81v12.667h14.476v-1.81Zm.905-1.81V8.43h-6.333a2.714 2.714 0 0 0 0 5.428h6.334Zm-6.333-3.619h2.714v1.81h-2.714v-1.81Z"
      fill="currentColor"
      stroke="var(--main-bg-surface)"
      strokeWidth={0.6}
    />
  </svg>
);

export default WalletIcon;
